// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3OgHL","gfeWrapper":"CalendarEvent_gfeWrapper__1MGVQ"};